<script lang="ts" setup>
import { AppButton } from '@libs/ui';

import type { HomeFlightData } from './AirportSelector.model';

interface HomeAirportSelectorButtonProps {
  homeFlightData: HomeFlightData;
}
const props = defineProps<HomeAirportSelectorButtonProps>();
</script>

<template>
  <AppButton
    type="secondary"
    state="enabled"
    size="small"
    :left-icon="{
      size: '18',
      name: 'chevronDown',
    }"
    :right-icon="{
      size: '18',
      name: 'airplaneTakeoff',
    }"
  >
    {{ props.homeFlightData.airport.name }}
  </AppButton>
</template>
